import { post } from './index'
/**
 * 投资者关系
 */
export default {
  // 条件查询
  getNoticeByCondition: (params) => post('notice/getNoticeByCondition', params),
}
